import _classCallCheck from "/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { BufferGeometry, Float32BufferAttribute, OrthographicCamera, Mesh } from 'three';
var Pass = /*#__PURE__*/function () {
  function Pass() {
    _classCallCheck(this, Pass);
    // if set to true, the pass is processed by the composer
    this.enabled = true;

    // if set to true, the pass indicates to swap read and write buffer after rendering
    this.needsSwap = true;

    // if set to true, the pass clears its buffer before rendering
    this.clear = false;

    // if set to true, the result of the pass is rendered to screen. This is set automatically by EffectComposer.
    this.renderToScreen = false;
  }
  _createClass(Pass, [{
    key: "setSize",
    value: function setSize( /* width, height */) {}
  }, {
    key: "render",
    value: function render( /* renderer, writeBuffer, readBuffer, deltaTime, maskActive */
    ) {
      console.error('THREE.Pass: .render() must be implemented in derived pass.');
    }
  }, {
    key: "dispose",
    value: function dispose() {}
  }]);
  return Pass;
}(); // Helper for passes that need to fill the viewport with a single quad.
var _camera = new OrthographicCamera(-1, 1, 1, -1, 0, 1);

// https://github.com/mrdoob/three.js/pull/21358

var _geometry = new BufferGeometry();
_geometry.setAttribute('position', new Float32BufferAttribute([-1, 3, 0, -1, -1, 0, 3, -1, 0], 3));
_geometry.setAttribute('uv', new Float32BufferAttribute([0, 2, 0, 0, 2, 0], 2));
var FullScreenQuad = /*#__PURE__*/function () {
  function FullScreenQuad(material) {
    _classCallCheck(this, FullScreenQuad);
    this._mesh = new Mesh(_geometry, material);
  }
  _createClass(FullScreenQuad, [{
    key: "dispose",
    value: function dispose() {
      this._mesh.geometry.dispose();
    }
  }, {
    key: "render",
    value: function render(renderer) {
      renderer.render(this._mesh, _camera);
    }
  }, {
    key: "material",
    get: function get() {
      return this._mesh.material;
    },
    set: function set(value) {
      this._mesh.material = value;
    }
  }]);
  return FullScreenQuad;
}();
export { Pass, FullScreenQuad };